export default "__VITE_ASSET__DDlhok64__"